import { render } from "@testing-library/react";

const defaultRender = (value) => (value ? value : '--');
const columns = [
    {
        title: 'Name',
        dataIndex: 'name',
        render:defaultRender
    },
    {
        title: 'Email',
        dataIndex: 'email',
        sorter: true
    },
    {
        title: 'Mobile No.',
        dataIndex: 'phoneNo',
    },
    {
        title: 'Wallet Account Number',
        dataIndex: 'walletAccountNo',
        sorter: true
    },
    {
        title:'Balance',
        dataIndex: 'balance',
        sorter: true
    },
    {
        title:'Amount',
        dataIndex: 'requestedAmount',
        sorter: true
    },
    {
        title:'Comment',
        dataIndex: 'comment',
    },
    // {
    //     title:'Document',
    //     dataIndex: 'documentUrl',
    // },
    {
        title:'Request Date',
        dataIndex: 'requestDate',
        sorter: true
    },
    {
        title:'Status',
        dataIndex: 'status',
    },
    {
        title:'Actions',
        dataIndex: 'actions',
    },
    
   
];


export default columns;